import { ChordLib, ScaleLib } from '@tunasong/music-lib'
import type { Chord } from '@tunasong/music-lib'
import type { Scale } from '@tunasong/schemas'
import type { ChangeEvent, FC } from 'react'
import styles from './reharm-chord-picker.module.css'

const DIATONIC_DEGREES = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII'] as const

export interface ReharmChordPickerProps {
  keyScale: Scale
  chord: Chord
  diatonicOnly: boolean
  /** The select's accessible name, e.g. "Chord 2": a bare select is announced as "combo box" only */
  label: string
  onChange: (chord: Chord) => void
}

/**
 * Diatonic chord picker for Reharm Lab v1. v1 ships diatonic-only;
 * `diatonicOnly` is plumbed for forward compatibility but only the diatonic
 * branch is wired today. Freeform (chromatic) selection is a v2 follow-up.
 */
export const ReharmChordPicker: FC<ReharmChordPickerProps> = props => {
  const { keyScale, chord, label, onChange } = props

  const options: Chord[] = DIATONIC_DEGREES.map(d => ScaleLib.getChordByScaleDegree(keyScale, d)).filter(
    (c): c is NonNullable<typeof c> => c !== null
  )

  const handleChange = (e: ChangeEvent<HTMLSelectElement>): void => {
    const selected = options.find(o => ChordLib.getName(o) === e.target.value)
    if (selected) {
      onChange(selected)
    }
  }

  return (
    <select className={styles.picker} aria-label={label} value={ChordLib.getName(chord)} onChange={handleChange}>
      {options.map(o => (
        <option key={ChordLib.getName(o)} value={ChordLib.getName(o)}>
          {ChordLib.getName(o)}
        </option>
      ))}
    </select>
  )
}
